import { configureStore } from '@reduxjs/toolkit';
import settingReducer from './setting/reducers';
import childRegistrationReducer from './childRegistration/childRegistrationSlice';
import dailyReportReducer from './dailyReport/dailyReportSlice';
import noPeanutPolicyReducer from './noPeanutPolicy/noPeanutPolicySlice';
import lunchPlanWaiverReducer from './lunchPlanWaiver/lunchPlanWaiverSlice';
import emergencyContactReducer from './emergencyContact/emergencyContactSlice';
import allergyActionPlanReducer from './allergyActionPlan/allergyActionPlanSlice';

export const store = configureStore({
  reducer: {
    setting: settingReducer,
    childRegistration: childRegistrationReducer,
    dailyReport: dailyReportReducer,
    noPeanutPolicy: noPeanutPolicyReducer,
    lunchPlanWaiver: lunchPlanWaiverReducer,
    emergencyContact: emergencyContactReducer,
    allergyActionPlan: allergyActionPlanReducer,
  }
});
